// @flow
import React from 'react'
import glamorous from 'glamorous'
import { Navigation, Wrapper } from 'components'
import { padding, typography, colors, breakpoint, margin } from 'style'

const StyledFooter = glamorous.footer({
  borderTop: '1px solid #e6e6e6',
})

const Content = glamorous.div({
  ...padding.y(4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  ...breakpoint.small({
    flexDirection: 'column',
  }),
})

const Copyright = glamorous.p({
  ...typography.nav,
  color: colors.gray500,
  ...breakpoint.small({
    ...margin.top(2),
    order: 1,
  }),
})

const Footer = () => (
  <StyledFooter>
    <Wrapper>
      <Content>
        <Copyright>© {new Date().getFullYear()} Melissa O’Hearn</Copyright>
        <Navigation subtle />
      </Content>
    </Wrapper>
  </StyledFooter>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js